import {ViewportLayoutConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/ViewportLayoutConfig';
import {ViewportLayoutModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/ViewportLayoutModel';
import {ChildLayoutModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/ChildLayoutModel';
import {ChildLayoutModelConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/ChildLayoutModelConfig';
import {LayoutModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/LayoutModel';
import {LayoutModelConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/LayoutModelConfig';
import {AutofocusConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/autofocus/AutofocusConfig';
import {DnDModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/dnd/DnDModel';
import {DnDModelConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/dnd/DnDModelConfig';
import {KeepProportionsConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/keepProportions/KeepProportionsConfig';
import {LoaderConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/loader/LoaderConfig';
import {LoaderModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/loader/LoaderModel';
import {LockConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/lock/LockConfig';
import {OpacityConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/opacity/OpacityConfig';
import {OpacityModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/opacity/OpacityModel';
import {PerspectiveConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/perspective/PerspectiveConfig';
import {PerspectiveModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/perspective/PerspectiveModel';
import {PropConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/PropConfig';
import {RepeaterModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterModel';
import {RepeaterModelConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/RepeaterModelConfig';
import {RotationConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/rotation/RotationConfig';
import {RotationModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/rotation/RotationModel';
import {ScaleConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/scale/ScaleConfig';
import {ScaleModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/scale/ScaleModel';
import {ScrollbarConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/scrollbar/ScrollbarConfig';
import {ScrollbarModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/scrollbar/ScrollbarModel';
import {SkewConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/skew/SkewConfig';
import {SkewModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/skew/SkewModel';
import {VisibilityConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/visibility/VisibilityConfig';
import {EventMap} from '@mintdata/mint-kit/api/events/EventMap';
import {EventSpec} from '@mintdata/mint-kit/api/events/EventSpec';
import {CursorModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/cursor/CursorModel';
import {CursorConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/cursor/CursorConfig';
import {LayoutHorizontal} from '@mintdata/mint-kit/api/models/LayoutHorizontal';
import {LayoutVertical} from '@mintdata/mint-kit/api/models/LayoutVertical';
import {PositiveUnits} from '@mintdata/mint-kit/api/models/PositiveUnits';
import {Units} from '@mintdata/mint-kit/api/models/Units';
import {BindingConfig} from '@mintdata/mint-kit/api/properties/BindingConfig';
import {PropertyCategory} from '@mintdata/mint-kit/api/properties/PropertyCategory';
import {PropertySpec, PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {AStringConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AStringConfig';
import {SimpleUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/UnitsConfig';

export class SystemPropsConfigs
{
    public static fillLayoutPropsConfigs(layoutPropertiesConfigs:Map<PropName, PropConfig<any>>):void
    {
        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_PROP_NAME,
            new PropConfig<LayoutModel>(new PropertySpec<LayoutModel>(SystemPropsConfigs.LAYOUT_PROP_NAME,
                'Layout',
                'Layout',
                PropertyCategory.Common,
                false,
                true,
                false,
                LayoutModelConfig,
                LayoutModel,
                BindingConfig.alwaysOn(null),
                false
                ),
                new LayoutModel()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.CHILD_LAYOUT_PROP_NAME,
            new PropConfig<ChildLayoutModel>(new PropertySpec<ChildLayoutModel>(SystemPropsConfigs.CHILD_LAYOUT_PROP_NAME,
                'Child Layout',
                'Child Layout',
                PropertyCategory.Common,
                false,
                true,
                false,
                ChildLayoutModelConfig,
                ChildLayoutModel,
                BindingConfig.alwaysOn(null),
                false
                ),
                new ChildLayoutModel()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_LEFT_PROP_NAME,
            new PropConfig<Units>(new PropertySpec<Units>(SystemPropsConfigs.LAYOUT_LEFT_PROP_NAME,
                'Left',
                'Component Left Position',
                PropertyCategory.Common,
                false,
                true,
                false,
                SimpleUnitsConfig,
                Units,
                BindingConfig.alwaysOn(null),
                false
                ),
                Units.fromPixels(0)
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_TOP_PROP_NAME,
            new PropConfig<Units>(new PropertySpec<Units>(SystemPropsConfigs.LAYOUT_TOP_PROP_NAME,
                'Top',
                'Component Top Position',
                PropertyCategory.Common,
                false,
                true,
                false,
                SimpleUnitsConfig,
                Units,
                BindingConfig.alwaysOn(null),
                false
                ),
                Units.fromPixels(0)
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_RIGHT_PROP_NAME,
            new PropConfig<Units>(new PropertySpec<Units>(SystemPropsConfigs.LAYOUT_RIGHT_PROP_NAME,
                'Right',
                'Component Right Position',
                PropertyCategory.Common,
                false,
                true,
                false,
                SimpleUnitsConfig,
                Units,
                BindingConfig.alwaysOn(null),
                false
                ),
                Units.fromPixels(0)
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_BOTTOM_PROP_NAME,
            new PropConfig<Units>(new PropertySpec<Units>(SystemPropsConfigs.LAYOUT_BOTTOM_PROP_NAME,
                'Bottom',
                'Component Bottom Position',
                PropertyCategory.Common,
                false,
                true,
                false,
                SimpleUnitsConfig,
                Units,
                BindingConfig.alwaysOn(null),
                false
                ),
                Units.fromPixels(0)
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_WIDTH_PROP_NAME,
            new PropConfig<PositiveUnits>(new PropertySpec<PositiveUnits>(SystemPropsConfigs.LAYOUT_WIDTH_PROP_NAME,
                'Width',
                'Component Width',
                PropertyCategory.Common,
                false,
                true,
                false,
                SimpleUnitsConfig,
                PositiveUnits,
                BindingConfig.alwaysOn(null),
                false
                ),
                PositiveUnits.fromPixels(600)
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_HEIGHT_PROP_NAME,
            new PropConfig<PositiveUnits>(new PropertySpec<PositiveUnits>(SystemPropsConfigs.LAYOUT_HEIGHT_PROP_NAME,
                'Height',
                'Component Height',
                PropertyCategory.Common,
                false,
                true,
                false,
                SimpleUnitsConfig,
                PositiveUnits,
                BindingConfig.alwaysOn(null),
                false
                ),
                PositiveUnits.fromPixels(400)
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_VERTICAL_PROP_NAME,
            new PropConfig<LayoutVertical>(new PropertySpec<LayoutVertical>(SystemPropsConfigs.LAYOUT_VERTICAL_PROP_NAME,
                'Vertical',
                'Vertical Layout',
                PropertyCategory.Common,
                false,
                true,
                false,
                AStringEnumConfig,
                LayoutVertical,
                BindingConfig.alwaysOn(null),
                false
                ),
                LayoutVertical.top()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_HORIZONTAL_PROP_NAME,
            new PropConfig<LayoutHorizontal>(new PropertySpec<LayoutHorizontal>(SystemPropsConfigs.LAYOUT_HORIZONTAL_PROP_NAME,
                'Horizontal',
                'Horizontal Layout',
                PropertyCategory.Common,
                false,
                true,
                false,
                AStringEnumConfig,
                LayoutHorizontal,
                BindingConfig.alwaysOn(null),
                false
                ),
                LayoutHorizontal.left()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.LAYOUT_KEEP_PROPORTIONS_PROP_NAME,
            new PropConfig<ABoolean>(new PropertySpec<ABoolean>(SystemPropsConfigs.LAYOUT_KEEP_PROPORTIONS_PROP_NAME,
                'Keep proportions',
                'Keep proportions',
                PropertyCategory.Common,
                false,
                true,
                false,
                KeepProportionsConfig,
                ABoolean,
                BindingConfig.alwaysOn(null),
                false
                ),
                ABoolean.false()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.ROTATION_PROP_NAME,
            new PropConfig<RotationModel>(new PropertySpec<RotationModel>(SystemPropsConfigs.ROTATION_PROP_NAME,
                'Rotation',
                'Component Rotation',
                PropertyCategory.Common,
                false,
                true,
                false,
                RotationConfig,
                RotationModel,
                BindingConfig.with('@*'),
                false
                ),
                RotationModel.default()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.SCALE_PROP_NAME,
            new PropConfig<ScaleModel>(new PropertySpec<ScaleModel>(SystemPropsConfigs.SCALE_PROP_NAME,
                'Scale',
                'Component Scale',
                PropertyCategory.Common,
                false,
                true,
                false,
                ScaleConfig,
                ScaleModel,
                BindingConfig.with('@*'),
                false
                ),
                ScaleModel.default()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.SKEW_PROP_NAME,
            new PropConfig<SkewModel>(new PropertySpec<SkewModel>(SystemPropsConfigs.SKEW_PROP_NAME,
                'Skew',
                'Component Skew',
                PropertyCategory.Common,
                false,
                true,
                false,
                SkewConfig,
                SkewModel,
                BindingConfig.with('@*'),
                false
                ),
                SkewModel.default()
            )
        );

        layoutPropertiesConfigs.set(
            SystemPropsConfigs.PERSPECTIVE_PROP_NAME,
            new PropConfig<PerspectiveModel>(new PropertySpec<PerspectiveModel>(SystemPropsConfigs.PERSPECTIVE_PROP_NAME,
                'Perspective',
                'Component Perspective',
                PropertyCategory.Common,
                false,
                true,
                false,
                PerspectiveConfig,
                PerspectiveModel,
                BindingConfig.with('@*'),
                false
                ),
                PerspectiveModel.default()
            )
        );
    }

    public static fillBasePropsConfigs(basePropertiesConfigs:Map<PropName, PropConfig<any>>):void
    {
        basePropertiesConfigs.set(
            SystemPropsConfigs.NAME_PROP_NAME,
            new PropConfig<AString>(new PropertySpec<AString>(SystemPropsConfigs.NAME_PROP_NAME,
                'Name',
                'Component Name',
                PropertyCategory.Common,
                false,
                true,
                false,
                AStringConfig,
                AString,
                BindingConfig.none(),
                false
                ),
                AString.fromString('')
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.CATEGORY_PROP_NAME,
            new PropConfig<AString>(new PropertySpec<AString>(SystemPropsConfigs.CATEGORY_PROP_NAME,
                'Category',
                'Component Category',
                PropertyCategory.Common,
                false,
                true,
                false,
                AStringConfig,
                AString,
                BindingConfig.none(),
                false
                ),
                AString.fromString('Visual Components')
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.REPEATER_PROP_NAME,
            new PropConfig<RepeaterModel>(new PropertySpec<RepeaterModel>(SystemPropsConfigs.REPEATER_PROP_NAME,
                'Repeater',
                'Repeater',
                PropertyCategory.Common,
                false,
                false,
                false,
                RepeaterModelConfig,
                RepeaterModel,
                BindingConfig.with('@*'),
                false
                ),
                new RepeaterModel(AInteger.fromNumber(1))
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.VISIBILITY_PROP_NAME,
            new PropConfig<ABoolean>(new PropertySpec<ABoolean>(SystemPropsConfigs.VISIBILITY_PROP_NAME,
                'Visibility',
                'Is Visible',
                PropertyCategory.Common,
                false,
                false,
                false,
                VisibilityConfig,
                ABoolean,
                BindingConfig.with('@*'),
                false
                ),
                ABoolean.true()
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.LOCK_PROP_NAME,
            new PropConfig<ABoolean>(new PropertySpec<ABoolean>(SystemPropsConfigs.LOCK_PROP_NAME,
                'Lock',
                'Is Locked',
                PropertyCategory.Common,
                false,
                false,
                false,
                LockConfig,
                ABoolean,
                BindingConfig.with('@*'),
                false
                ),
                ABoolean.false()
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.LOADER_PROP_NAME,
            new PropConfig<LoaderModel>(new PropertySpec<LoaderModel>(SystemPropsConfigs.LOADER_PROP_NAME,
                'Loader',
                'Loader',
                PropertyCategory.Common,
                false,
                false,
                false,
                LoaderConfig,
                LoaderModel,
                BindingConfig.with('@*'),
                false
                ),
                LoaderModel.default()
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.AUTOFOCUS_PROP_NAME,
            new PropConfig<ABoolean>(new PropertySpec<ABoolean>(SystemPropsConfigs.AUTOFOCUS_PROP_NAME,
                '',
                '',
                PropertyCategory.Common,
                false,
                false,
                false,
                AutofocusConfig,
                ABoolean,
                BindingConfig.with('@*'),
                false
                ),
                ABoolean.false()
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.DND_PROP_NAME,
            new PropConfig<DnDModel>(new PropertySpec<DnDModel>(SystemPropsConfigs.DND_PROP_NAME,
                '',
                '',
                PropertyCategory.Common,
                false,
                false,
                false,
                DnDModelConfig,
                DnDModel,
                BindingConfig.with('@*'),
                false
                ),
                new DnDModel()
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.OPACITY_PROP_NAME,
            new PropConfig<OpacityModel>(new PropertySpec<OpacityModel>(SystemPropsConfigs.OPACITY_PROP_NAME,
                'Opacity',
                'Component Opacity',
                PropertyCategory.Common,
                false,
                true,
                false,
                OpacityConfig,
                OpacityModel,
                BindingConfig.with('@*'),
                false
                ),
                OpacityModel.default()
            )
        );

        // app level properties
        basePropertiesConfigs.set(
            SystemPropsConfigs.VIEWPORT_LAYOUT_PROP_NAME,
            new PropConfig<ViewportLayoutModel>(
                new PropertySpec<ViewportLayoutModel>(SystemPropsConfigs.VIEWPORT_LAYOUT_PROP_NAME,
                    'Viewport Layout',
                    'Viewport Layout',
                    PropertyCategory.Common,
                    false,
                    true,
                    true,
                    ViewportLayoutConfig,
                    ViewportLayoutModel,
                    BindingConfig.with('@*'),
                    false
                ),
                ViewportLayoutModel.default()
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.SCROLLBAR_PROP_NAME,
            new PropConfig<ScrollbarModel>(
                new PropertySpec<ScrollbarModel>(SystemPropsConfigs.SCROLLBAR_PROP_NAME,
                    'Scrollbar',
                    'Component Scrollbar',
                    PropertyCategory.Common,
                    false,
                    true,
                    true,
                    ScrollbarConfig,
                    ScrollbarModel,
                    BindingConfig.with('@*'),
                    false
                ),
                ScrollbarModel.default()
            )
        );

        basePropertiesConfigs.set(
            SystemPropsConfigs.CURSOR_PROP_NAME,
            new PropConfig<CursorModel>(
                new PropertySpec<CursorModel>(SystemPropsConfigs.CURSOR_PROP_NAME,
                    'Cursor',
                    'Component Cursor',
                    PropertyCategory.Common,
                    false,
                    true,
                    false,
                    CursorConfig,
                    CursorModel,
                    BindingConfig.with('@*'),
                    false
                ),
                CursorModel.default()
            )
        );
    }

    public static fillBaseEventsMap(baseEventsMap:EventMap):void
    {
        baseEventsMap.add(
            new EventSpec(
                SystemPropsConfigs.DND_ON_DRAG_STARTED_EVENT_NAME,
                false,
                SystemPropsConfigs.DND_ON_DRAG_STARTED_EVENT_NAME,
                '',
                false
            )
        );

        baseEventsMap.add(
            new EventSpec(
                SystemPropsConfigs.DND_ON_DRAG_IN_PROGRESS_EVENT_NAME,
                false,
                SystemPropsConfigs.DND_ON_DRAG_IN_PROGRESS_EVENT_NAME,
                '',
                false
            )
        );

        baseEventsMap.add(
            new EventSpec(
                SystemPropsConfigs.DND_ON_DROP_EVENT_NAME,
                false,
                SystemPropsConfigs.DND_ON_DROP_EVENT_NAME,
                '',
                false
            )
        );
    }

    public static fillSurfaceEventsMap(surfaceEventsMap:EventMap):void
    {
        surfaceEventsMap.add(
            new EventSpec(
                SystemPropsConfigs.APPLICATION_LOAD_EVENT_PROP_NAME,
                false,
                SystemPropsConfigs.APPLICATION_LOAD_EVENT_PROP_NAME,
                'Application loaded event',
                false
            )
        );

        surfaceEventsMap.add(
            new EventSpec(
                SystemPropsConfigs.VIEWPORT_RESIZE_EVENT_PROP_NAME,
                false,
                SystemPropsConfigs.VIEWPORT_RESIZE_EVENT_PROP_NAME,
                'Viewport resized event',
                false
            )
        );

        surfaceEventsMap.add(
            new EventSpec(
                SystemPropsConfigs.POST_MESSAGE_PROP_NAME,
                false,
                SystemPropsConfigs.POST_MESSAGE_PROP_NAME,
                'PostMessage event',
                false
            )
        );
    }

    public static readonly basePropertiesConfigs:Map<PropName, PropConfig<any>> = new Map();
    public static readonly layoutPropertiesConfigs:Map<PropName, PropConfig<any>> = new Map();
    public static readonly baseEventsMap:EventMap = new EventMap();
    public static readonly surfaceEventsMap:EventMap = new EventMap();

    // application level props
    public static readonly APPLICATION_LOAD_EVENT_PROP_NAME:string = 'onApplicationLoad';
    public static readonly VIEWPORT_RESIZE_EVENT_PROP_NAME:string = 'onViewportResize';
    public static readonly VIEWPORT_LAYOUT_PROP_NAME:string = 'viewportLayout';
    public static readonly SCROLLBAR_PROP_NAME:string = 'scrollbar';
    public static readonly POST_MESSAGE_PROP_NAME:string = 'onPostMessage';

    // component level props
    public static readonly NAME_PROP_NAME:string = 'name';
    public static readonly CATEGORY_PROP_NAME:string = 'category';
    public static readonly REPEATER_PROP_NAME:string = 'repeater';
    public static readonly VISIBILITY_PROP_NAME:string = 'visibility';
    public static readonly DND_PROP_NAME:string = 'dnd';
    public static readonly LOCK_PROP_NAME:string = 'lock';
    public static readonly LOADER_PROP_NAME:string = 'loader';
    public static readonly ROTATION_PROP_NAME:string = 'rotation';
    public static readonly AUTOFOCUS_PROP_NAME:string = 'autofocus';
    public static readonly SCALE_PROP_NAME:string = 'scale';
    public static readonly OPACITY_PROP_NAME:string = 'opacity';
    public static readonly SKEW_PROP_NAME:string = 'skew';
    public static readonly PERSPECTIVE_PROP_NAME:string = 'perspective';

    public static readonly LAYOUT_PROP_NAME:string = 'layout';
    public static readonly CHILD_LAYOUT_PROP_NAME:string = 'childLayout';
    public static readonly LAYOUT_TOP_PROP_NAME:string = 'layoutTop';
    public static readonly LAYOUT_LEFT_PROP_NAME:string = 'layoutLeft';
    public static readonly LAYOUT_RIGHT_PROP_NAME:string = 'layoutRight';
    public static readonly LAYOUT_BOTTOM_PROP_NAME:string = 'layoutBottom';

    public static readonly LAYOUT_WIDTH_PROP_NAME:string = 'layoutWidth';
    public static readonly LAYOUT_HEIGHT_PROP_NAME:string = 'layoutHeight';

    public static readonly LAYOUT_VERTICAL_PROP_NAME:string = 'layoutVertical';
    public static readonly LAYOUT_HORIZONTAL_PROP_NAME:string = 'layoutHorizontal';
    public static readonly LAYOUT_KEEP_PROPORTIONS_PROP_NAME:string = 'layoutKeepProportions';

    public static readonly DND_ON_DRAG_STARTED_EVENT_NAME:string = 'onDragStarted';
    public static readonly DND_ON_DRAG_IN_PROGRESS_EVENT_NAME:string = 'onDragInProgress';
    public static readonly DND_ON_DROP_EVENT_NAME:string = 'onDrop';

    public static readonly CURSOR_PROP_NAME:string = 'cursor';
}

SystemPropsConfigs.fillBasePropsConfigs(SystemPropsConfigs.basePropertiesConfigs);
SystemPropsConfigs.fillLayoutPropsConfigs(SystemPropsConfigs.layoutPropertiesConfigs);
SystemPropsConfigs.fillBaseEventsMap(SystemPropsConfigs.baseEventsMap);
SystemPropsConfigs.fillSurfaceEventsMap(SystemPropsConfigs.surfaceEventsMap);
